// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+390828997539",
  numero_telefono: "tel:+390828997539",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',
  */

  urlWeb: 'https://discentya.centrostudiboethos.com/',
  urlMaterialeDidattico: 'https://discentya.centrostudiboethos.com/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.centrostudiboethos.com/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.centrostudiboethos.com/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.centrostudiboethos.com/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.centrostudiboethos.com/api/',

  urlStampa: 'https://discentya.centrostudiboethos.com/stampe/',

  urlAttestati: 'https://discentya.centrostudiboethos.com/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.centrostudiboethos.com/pages/certificate/',
  urlImagePartners: 'https://discentya.centrostudiboethos.com/assets/media/partners/',
  urlImageMedia: 'https://discentya.centrostudiboethos.com/assets/media/',

};

